import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FrameIn } from 'projects/shared/src/interfaces/frame-in.interface';
import { FrameOutResponse } from 'projects/shared/src/interfaces/frame-out-response.interface';
import { Observable } from 'rxjs';
import { ShHeadersService } from '../headers/sh-headers.service';

@Injectable({
  providedIn: 'root',
})
export class ShLoanApplicationService {
  constructor(
    private http: HttpClient,
    private _shSharedHeaders: ShHeadersService
  ) {}

  shGetLoanApplication(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    let headers = this._shSharedHeaders.buildHeaders(request, envHeaders);
    headers = headers.append('id-type', 'CED');
    return this.http.get<FrameOutResponse>(`${url}`, {
      headers,
    });
  }

  shSendLoanApplication(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    return this.http.post<FrameOutResponse>(
      `${url}`,
      this._shSharedHeaders.buildBody(request),
      {
        headers: this._shSharedHeaders.buildHeaders(request, envHeaders),
      }
    );
  }
}
